import { Box, IconButton, TableHead, TableRow } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { Column, SortOrder } from './SmartTableDefinitions'
import SmartTableHeaderColumns from './SmartTableHeaderColumns'

interface P {
    columns: Column[]
    order?: SortOrder
    orderBy?: string
    onSort?: (column: Column) => void
    onClickAddButton?: () => void
    sticky?: boolean
}

function SmartTableHeader({ columns, order, orderBy, sticky, onSort, onClickAddButton }: P) {
    const shownColumns = columns.filter(x => !x.hidden)

    return (
        <TableHead style={sticky ? { position: 'sticky', top: -25, zIndex: 10 } : {}}>
            <TableRow style={{ position: 'relative', width: '100%' }}>
                {shownColumns.map(column => (
                    <SmartTableHeaderColumns
                        key={column.id}
                        column={column}
                        orderBy={orderBy}
                        order={order}
                        onSort={onSort}
                    />
                ))}
                {onClickAddButton && (
                    <Box position='absolute' top={0} right={0} zIndex={99}>
                        <IconButton aria-label='expand row' size='small' onClick={onClickAddButton}>
                            <AddIcon />
                        </IconButton>
                    </Box>
                )}
            </TableRow>
        </TableHead>
    )
}

export default SmartTableHeader
